import { Component, OnInit } from '@angular/core';
import { PatientCartActionTypes, AppState } from '@app/core/ngrx';
import { Store, select } from '@ngrx/store';

@Component({
  selector: 'ecp-patient-carts',
  templateUrl: './patient-carts.component.html',
  styleUrls: ['./patient-carts.component.scss'],
})
export class PatientCartsComponent implements OnInit {
  constructor(private store: Store<AppState>) {}
  cart$: any;

  ngOnInit() {
    this.store.dispatch({ type: PatientCartActionTypes.LOAD_PATIENT_CART });
    this.cart$ = this.store.pipe(select(state => state.patientCart.cart));
  }
}
